import { Injectable, computed, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResumenDashboardDTO, ResumenEntreFechas } from './dashboard.types';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DashboardService {

  private resumen = signal<ResumenDashboardDTO | null>(null);
  private entreFechas = signal<ResumenEntreFechas | null>(null);

  resumen$ = this.resumen.asReadonly();
  entreFechas$ = this.entreFechas.asReadonly();

  private baseUrl = environment.apiUrl + '/dashboard';

  constructor(private http: HttpClient) {}

  cargarResumen(limite: number):Observable<ResumenDashboardDTO> {
    return this.http.get<ResumenDashboardDTO>(`${this.baseUrl}/resumen/${limite}`).pipe(
      tap(res => this.resumen.set(res)));
  }

  aplicarFiltro(fecha1: Date, fecha2: Date):Observable<ResumenEntreFechas> {
    return this.http.get<ResumenEntreFechas>(`${this.baseUrl}/resumen-entre/${fecha1}&${fecha2}`).pipe(tap(res => this.entreFechas.set(res)));
  }
}
